import { render, staticRenderFns } from "./MarkedItemsView.vue?vue&type=template&id=30027c91&"
import script from "./MarkedItemsView.vue?vue&type=script&lang=js&"
export * from "./MarkedItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports